import React from 'react';

const ProxyPlanIcon = () => (
  <svg 
    id="Layer_1" 
    viewBox="0 0 1000 1000" 
    xmlns="http://www.w3.org/2000/svg" 
    data-name="Layer 1"
    width="24"
    height="24"
  >
    {/* Base shapes */}
    <rect 
      height="59.32" 
      rx="29.66" 
      width="24" 
      x="229.98" 
      y="90" 
    />

    {/* Vertical bars */}
    <path d="m263.64 141.69h59.33v130.55h-59.33z" />
    <path d="m444.97 141.69h59.33v130.55h-59.33z" />

    {/* Bottom feet */}
    <path d="m216 850.33h70.73a0 0 0 0 1 0 0v28a31.63 31.63 0 0 1 -31.59 31.67h-7.48a31.63 31.63 0 0 1 -31.66-31.63v-28a0 0 0 0 1 0-.04z" />
    <path d="m481.18 850.33h70.73a0 0 0 0 1 0 0v28a31.63 31.63 0 0 1 -31.63 31.67h-7.48a31.63 31.63 0 0 1 -31.63-31.63v-28a0 0 0 0 1 .01-.04z" />

    {/* Main body structure */}
    <path d="m505.07 745.94v-5h-280.3a10 10 0 1 1 0-20h280.3v-73.75h-280.3a10 10 0 1 1 0-20h280.3v-73.74h-280.3a10 10 0 1 1 0-20h280.3v-83.74h-264.69a25.61 25.61 0 0 1 -25.61-25.61v-34.47a25.6 25.6 0 0 1 25.61-25.63h264.71c0-.3 0-.61 0-.91a49.08 49.08 0 0 1 49.19-47.09h51.17a53.13 53.13 0 0 1 4.79-8.59 49.29 49.29 0 0 1 7.1-8.22 77.19 77.19 0 0 0 -64.43-34.62h-337.91a77.29 77.29 0 0 0 -77.29 77.3v411.13a77.28 77.28 0 0 0 77.29 77.33h337.91a77.21 77.21 0 0 0 64.81-35.18h-63.44a49.26 49.26 0 0 1 -49.21-49.21z" />

    {/* Top section with details */}
    <path d="m760.53 364.25h-133.75c-5.31 0-9.33-6.08-8.39-12.71l2.21-15.54.25-1.85a36 36 0 0 1 5.85-15.37c4.65-6.78 11.52-11 19-11a13.13 13.13 0 0 0 7.8-2.56 12.5 12.5 0 0 0 4.66-6.72 34.36 34.36 0 0 1 33.06-25h4.78a34.33 34.33 0 0 1 33.06 25 12.9 12.9 0 0 0 12.47 9.28 22.31 22.31 0 0 1 16.21 7.46 34.35 34.35 0 0 1 8.67 18.89l.27 1.85 2.21 15.5c.98 6.69-3.04 12.77-8.36 12.77z" />

    {/* Main container */}
    <path d="m833 336h-46.08l1.81 12.69a32.38 32.38 0 0 1 -7.36 25.83 27.7 27.7 0 0 1 -20.84 9.69h-133.74a27.69 27.69 0 0 1 -20.86-9.71 32.3 32.3 0 0 1 -7.33-25.83l1.79-12.67h-46.12a29.22 29.22 0 0 0 -29.18 28v1.24 380.7a29.2 29.2 0 0 0 29.21 29.21h278.7a29.21 29.21 0 0 0 29.21-29.21v-380.68a29.22 29.22 0 0 0 -29.21-29.26zm-194.63 366.3-32.63 32.63a12.51 12.51 0 0 1 -17.68 0l-17.38-17.38a12.5 12.5 0 0 1 17.67-17.68l8.55 8.55 23.79-23.8a12.5 12.5 0 0 1 17.68 17.68zm0-86.72-32.63 32.63a12.48 12.48 0 0 1 -17.68 0l-17.38-17.38a12.5 12.5 0 0 1 17.67-17.68l8.55 8.55 23.79-23.8a12.5 12.5 0 0 1 17.68 17.68zm0-86.72-32.63 32.64a12.51 12.51 0 0 1 -17.68 0l-17.38-17.39a12.5 12.5 0 0 1 17.67-17.68l8.55 8.57 23.79-23.79a12.5 12.5 0 0 1 17.68 17.67zm0-86.71-32.63 32.63a12.51 12.51 0 0 1 -17.68 0l-17.38-17.39a12.49 12.49 0 0 1 17.67-17.67l8.55 8.54 23.79-23.79a12.5 12.5 0 0 1 17.68 17.68zm171.94 277.63h-122.31a10 10 0 0 1 0-20h122.31a10 10 0 0 1 0 20zm0-86.72h-122.31a10 10 0 0 1 0-20h122.31a10 10 0 0 1 0 20zm0-86.72h-122.31a10 10 0 0 1 0-20h122.31a10 10 0 0 1 0 20zm0-86.72h-122.31a10 10 0 0 1 0-20h122.31a10 10 0 0 1 0 20z" />
  </svg>
);

export default ProxyPlanIcon;
